import type { PropsWithChildren } from "react";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HostStoreEventEmitter } from "host/HostStore";
import AppContext from "store/context/AppContext/AppContext";
import { NAVIGATE_FROM_HOST_WITH_URL_EVENT_ID } from "store/zustand/HostStore/HostStore.listeners";

const OnboardingLayout = (props: PropsWithChildren) => {
    const appCtx = useContext(AppContext);
    const navigate = useNavigate();

    const navigateFromHostWithURLHandler = (url: string) => {
        navigate(url);
    };

    useEffect(() => {
        HostStoreEventEmitter.getEventEmitter().on(
            NAVIGATE_FROM_HOST_WITH_URL_EVENT_ID,
            navigateFromHostWithURLHandler
        );

        HostStoreEventEmitter.registerEventSubscription(
            NAVIGATE_FROM_HOST_WITH_URL_EVENT_ID,
            navigateFromHostWithURLHandler
        );

        return () => {
            HostStoreEventEmitter.removeAllEventListeners();
            appCtx.setExecuteOnBoardingCompleteCheck(true);
        };
    }, []);

    return props.children;
};

export default OnboardingLayout;
